// @ts-nocheck
import frame0 from '@/components/games/dice/images/cup/cup_00000.png';
import frame1 from '@/components/games/dice/images/cup/cup_00001.png';
import frame2 from '@/components/games/dice/images/cup/cup_00002.png';
import frame3 from '@/components/games/dice/images/cup/cup_00003.png';
import frame4 from '@/components/games/dice/images/cup/cup_00004.png';
import frame5 from '@/components/games/dice/images/cup/cup_00005.png';
import frame6 from '@/components/games/dice/images/cup/cup_00006.png';
import frame7 from '@/components/games/dice/images/cup/cup_00007.png';
import frame8 from '@/components/games/dice/images/cup/cup_00008.png';
import frame9 from '@/components/games/dice/images/cup/cup_00009.png';
import frame10 from '@/components/games/dice/images/cup/cup_00010.png';
import frame11 from '@/components/games/dice/images/cup/cup_00011.png';
import frame12 from '@/components/games/dice/images/cup/cup_00012.png';
import frame13 from '@/components/games/dice/images/cup/cup_00013.png';
import frame14 from '@/components/games/dice/images/cup/cup_00014.png';
import frame15 from '@/components/games/dice/images/cup/cup_00015.png';
import frame16 from '@/components/games/dice/images/cup/cup_00016.png';
import frame17 from '@/components/games/dice/images/cup/cup_00017.png';
import frame18 from '@/components/games/dice/images/cup/cup_00018.png';
import frame19 from '@/components/games/dice/images/cup/cup_00019.png';
import frame20 from '@/components/games/dice/images/cup/cup_00020.png';
import frame21 from '@/components/games/dice/images/cup/cup_00021.png';
import frame22 from '@/components/games/dice/images/cup/cup_00022.png';
import frame23 from '@/components/games/dice/images/cup/cup_00023.png';
import frame24 from '@/components/games/dice/images/cup/cup_00024.png';
import frame25 from '@/components/games/dice/images/cup/cup_00025.png';
import frame26 from '@/components/games/dice/images/cup/cup_00026.png';
import frame27 from '@/components/games/dice/images/cup/cup_00027.png';
import frame28 from '@/components/games/dice/images/cup/cup_00028.png';
import frame29 from '@/components/games/dice/images/cup/cup_00029.png';
import frame30 from '@/components/games/dice/images/cup/cup_00030.png';
import frame31 from '@/components/games/dice/images/cup/cup_00031.png';
import frame32 from '@/components/games/dice/images/cup/cup_00032.png';
import frame33 from '@/components/games/dice/images/cup/cup_00033.png';
import frame34 from '@/components/games/dice/images/cup/cup_00034.png';
import frame35 from '@/components/games/dice/images/cup/cup_00035.png';
import frame36 from '@/components/games/dice/images/cup/cup_00036.png';
import frame37 from '@/components/games/dice/images/cup/cup_00037.png';
import frame38 from '@/components/games/dice/images/cup/cup_00038.png';
import frame39 from '@/components/games/dice/images/cup/cup_00039.png';
import frame40 from '@/components/games/dice/images/cup/cup_00040.png';
import frame41 from '@/components/games/dice/images/cup/cup_00041.png';
import frame42 from '@/components/games/dice/images/cup/cup_00042.png';
import frame43 from '@/components/games/dice/images/cup/cup_00043.png';
import frame44 from '@/components/games/dice/images/cup/cup_00044.png';
import frame45 from '@/components/games/dice/images/cup/cup_00045.png';
import frame46 from '@/components/games/dice/images/cup/cup_00046.png';
import frame47 from '@/components/games/dice/images/cup/cup_00047.png';
import frame48 from '@/components/games/dice/images/cup/cup_00048.png';
import frame49 from '@/components/games/dice/images/cup/cup_00049.png';
import frame50 from '@/components/games/dice/images/cup/cup_00050.png';
import frame51 from '@/components/games/dice/images/cup/cup_00051.png';
import frame52 from '@/components/games/dice/images/cup/cup_00052.png';
import frame53 from '@/components/games/dice/images/cup/cup_00053.png';
import frame54 from '@/components/games/dice/images/cup/cup_00054.png';
import frame55 from '@/components/games/dice/images/cup/cup_00055.png';
import frame56 from '@/components/games/dice/images/cup/cup_00056.png';
import frame57 from '@/components/games/dice/images/cup/cup_00057.png';
import frame58 from '@/components/games/dice/images/cup/cup_00058.png';
import frame59 from '@/components/games/dice/images/cup/cup_00059.png';
import frame60 from '@/components/games/dice/images/cup/cup_00060.png';
import frame61 from '@/components/games/dice/images/cup/cup_00061.png';
import frame62 from '@/components/games/dice/images/cup/cup_00062.png';
import frame63 from '@/components/games/dice/images/cup/cup_00063.png';
import frame64 from '@/components/games/dice/images/cup/cup_00064.png';
import frame65 from '@/components/games/dice/images/cup/cup_00065.png';
import frame66 from '@/components/games/dice/images/cup/cup_00066.png';
import frame67 from '@/components/games/dice/images/cup/cup_00067.png';
import frame68 from '@/components/games/dice/images/cup/cup_00068.png';
import frame69 from '@/components/games/dice/images/cup/cup_00069.png';
import frame70 from '@/components/games/dice/images/cup/cup_00070.png';
import frame71 from '@/components/games/dice/images/cup/cup_00071.png';
import frame72 from '@/components/games/dice/images/cup/cup_00072.png';
import frame73 from '@/components/games/dice/images/cup/cup_00073.png';
import frame74 from '@/components/games/dice/images/cup/cup_00074.png';
import frame75 from '@/components/games/dice/images/cup/cup_00075.png';
import frame76 from '@/components/games/dice/images/cup/cup_00076.png';
import frame77 from '@/components/games/dice/images/cup/cup_00077.png';
import frame78 from '@/components/games/dice/images/cup/cup_00078.png';
import frame79 from '@/components/games/dice/images/cup/cup_00079.png';
import frame80 from '@/components/games/dice/images/cup/cup_00080.png';
import { fixAssetUrl } from '@/utilities/Utilities';

export default [
  fixAssetUrl(frame0),
  fixAssetUrl(frame1),
  fixAssetUrl(frame2),
  fixAssetUrl(frame3),
  fixAssetUrl(frame4),
  fixAssetUrl(frame5),
  fixAssetUrl(frame6),
  fixAssetUrl(frame7),
  fixAssetUrl(frame8),
  fixAssetUrl(frame9),
  fixAssetUrl(frame10),
  fixAssetUrl(frame11),
  fixAssetUrl(frame12),
  fixAssetUrl(frame13),
  fixAssetUrl(frame14),
  fixAssetUrl(frame15),
  fixAssetUrl(frame16),
  fixAssetUrl(frame17),
  fixAssetUrl(frame18),
  fixAssetUrl(frame19),
  fixAssetUrl(frame20),
  fixAssetUrl(frame21),
  fixAssetUrl(frame22),
  fixAssetUrl(frame23),
  fixAssetUrl(frame24),
  fixAssetUrl(frame25),
  fixAssetUrl(frame26),
  fixAssetUrl(frame27),
  fixAssetUrl(frame28),
  fixAssetUrl(frame29),
  fixAssetUrl(frame30),
  fixAssetUrl(frame31),
  fixAssetUrl(frame32),
  fixAssetUrl(frame33),
  fixAssetUrl(frame34),
  fixAssetUrl(frame35),
  fixAssetUrl(frame36),
  fixAssetUrl(frame37),
  fixAssetUrl(frame38),
  fixAssetUrl(frame39),
  fixAssetUrl(frame40),
  fixAssetUrl(frame41),
  fixAssetUrl(frame42),
  fixAssetUrl(frame43),
  fixAssetUrl(frame44),
  fixAssetUrl(frame45),
  fixAssetUrl(frame46),
  fixAssetUrl(frame47),
  fixAssetUrl(frame48),
  fixAssetUrl(frame49),
  fixAssetUrl(frame50),
  fixAssetUrl(frame51),
  fixAssetUrl(frame52),
  fixAssetUrl(frame53),
  fixAssetUrl(frame54),
  fixAssetUrl(frame55),
  fixAssetUrl(frame56),
  fixAssetUrl(frame57),
  fixAssetUrl(frame58),
  fixAssetUrl(frame59),
  fixAssetUrl(frame60),
  fixAssetUrl(frame61),
  fixAssetUrl(frame62),
  fixAssetUrl(frame63),
  fixAssetUrl(frame64),
  fixAssetUrl(frame65),
  fixAssetUrl(frame66),
  fixAssetUrl(frame67),
  fixAssetUrl(frame68),
  fixAssetUrl(frame69),
  fixAssetUrl(frame70),
  fixAssetUrl(frame71),
  fixAssetUrl(frame72),
  fixAssetUrl(frame73),
  fixAssetUrl(frame74),
  fixAssetUrl(frame75),
  fixAssetUrl(frame76),
  fixAssetUrl(frame77),
  fixAssetUrl(frame78),
  fixAssetUrl(frame79),
  fixAssetUrl(frame80)
];
